<template>
	<div class="information-description">
		Account connections are how Ply connects to your apps. Your information is secure and in your control.
		<DocsDispatcher docsSrc="https://info.ply.io/privacy">
			<a href="#">Learn more</a>
		</DocsDispatcher>
	</div>
</template>

<script>
import DocsDispatcher from '@/components/common/DocsDispatcher';

export default {
	name: 'ProfilePermissionExplanation',
	components: { DocsDispatcher },
};
</script>

<style scoped lang="scss">
.information-description {
	font-size: 10px;
	color: var(--description-text);
}
</style>
